import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'group flex items-baseline justify-between px-3.5 py-[0.438rem] text-[0.75rem] transition-colors ' +
            'duration-150 ease-out hover:bg-(--glass-chip-bg-hover)',
        label:
            'mr-2.5 shrink-0 font-(family-name:--secondary-font) text-[0.688rem] text-(--text-muted) ' +
            'transition-colors duration-150 ease-out group-hover:font-semibold group-hover:text-(--text-light)',
        value:
            'max-w-[60%] overflow-hidden text-ellipsis whitespace-nowrap text-right ' +
            'font-(family-name:--primary-font) group-hover:font-semibold'
    },
    variants: {
        borderVisible: {
            true: {
                root: 'border-b-[0.063rem] border-solid border-b-(--slate-alpha-12)'
            }
        },
        accent: {
            true: {
                value: 'text-(--accent-solid)'
            },
            false: {
                value: 'text-(--text-dark)'
            }
        }
    }
} satisfies ComponentTheme;
